import { createApp } from 'vue'
import App from './App.vue'
import VueGtag, { customMap } from 'vue-gtag'

import router from './router/index'
import store from './store/index' 
import VueApexCharts from "vue3-apexcharts"; 

import './assets/style.css'

const app = createApp(App);

const colorSet = ['brown', 'bluegrey', 'navy', 'red', 'blue', 'yellow', 'tan', 'darkbrown', 'white', 'green', 'lightbeige'];

app.config.globalProperties.$filters = {
  colorAssign(value) {
    if (!value) return '';
    value = value.toString().substring(2);
    const modulo = parseInt(value, 10) % 11;
    return colorSet[modulo];
  },
  getDate(timestamp){
    var ts = new Date(timestamp)
    return ts.toDateString()
  },
  getTime: function(timestamp){
    var ts = new Date(timestamp)
    return ts.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})
  },
  timeFormat(time){
    const mins = parseInt(
      time / 60,
      10
    );
    const secs = parseInt(
      time % 60,
      10
    );
    return mins + ":" + secs.toString().padStart(2, "0");
  },
  storyName(value){
    if (!value) return '';
    else if (value === 'story-1'){
      return 'Florence Mills'
    } 
    else if (value === 'story-2'){
      return 'Tiny Davis'
    }
  },
  levelName(level){
    if (!level) return '';
    switch(level) {
      case 'level-1': {
         return 'Dressing Room'
      }
      case 'level-2': {
        return 'Harlem Renaissance'
     }
      case 'level-3': {
        return 'Blackbirds'
      }
      case 'level-4': {
        return 'Funeral'
      }
      case 'level-5': {
        return 'Piney Woods'
      }
      case 'level-6': {
        return 'Bus'
      }
      case 'level-7': {
        return 'Howard Theatre'
      }
      case 'level-8': {
        return 'Gay Spot'
      }
      default: {
        return ''
      }
    }
  }
}

app.use(router).use(store).use(VueApexCharts).use(VueGtag, {
  config: {id: "G-E3E8522ZR2"}
}).mount('#app')


customMap({'dimension1': 'user_id_dimension'});


